import { buildQuery } from '~/utils'
import jsonp from 'jsonp'

export default {
  getRelated({
    url,
    q,
    u_q,
    q_all,
    related = 1,
    pp = 8,
    s_id,
    from_photo = 1,
    more_link,
    more_text = 'イラストを',
    sort = 'dlrank',
  }: any) {
    return new Promise((resolve, reject) => {
      jsonp(`${url}?${buildQuery({
        q,
        u_q,
        q_all,
        related,
        pp,
        s_id,
        from_photo,
        more_link,
        more_text,
        sort,
      })}`, (err: any, data: any) => {
        if (err) {
          reject(err)
        } else {
          resolve(data)
        }
      })
    })
  },
}
